var highlight = function (service) {
  $("#integrations")
    .off("shown.bs.modal.cfHighlight")
    .on("shown.bs.modal.cfHighlight", function () {
      var $body = $("#integrations .modal-body");
      var $integrationCol = $(
        '.integration-container[data-service="' + service + '"]'
      );

      if (!$body.length || !$integrationCol.length) {
        return;
      }

      var scrollPosition =
        $body.scrollTop() +
        $integrationCol.offset().top -
        $body.offset().top -
        24;

      $body.animate({ scrollTop: scrollPosition }, "fast");
      $("#integrations").off("shown.bs.modal.cfHighlight");
    });

  $("#integrations").modal("show");
  $("#quickLaunchModal").modal("hide");
  $('.integrations-install[data-service="' + service + '"]')
    .removeAttr("onclick")
    .css({
      opacity: "0.8",
      cursor: "initial",
    });
};

export default highlight;
